import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { RedactedField } from '../../../components/pii';

/**
 * Renders a PII-gated identity value (customer / inspector name, phone,
 * email) on the order detail (AUT-123). Mirrors the users `PiiCell`
 * pattern exactly: gate `copyable` on `revealed` (server truth via
 * `dto.piiRevealed`), never on a second client permission read. A `null`
 * value (no name / phone / email on record) renders the no-value dash —
 * mirroring the users email cell.
 */
export const OrderPiiValue = ({
  value,
  revealed,
}: {
  value: string | null;
  revealed: boolean;
}): ReactElement => {
  const { t } = useTranslation();
  if (!value) {
    return (
      <Typography variant="body2" color="text.secondary" component="span">
        {t('orders.detail.noValue')}
      </Typography>
    );
  }
  return (
    <RedactedField
      perm="view_pii"
      value={value}
      redacted={value}
      {...(revealed ? { copyable: true } : {})}
    />
  );
};
